import { yupResolver } from '@hookform/resolvers/yup';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { AdminSettingsLayout } from '../../../../common/components';
import { useAdvertisingSegments } from '../../../../common/hooks';
import { requiredFieldMessage } from '../../../../common/utils/validation.utils';
import AdvertisingSegmentForm from './AdvertisingSegmentForm';

export const schema = yup
    .object({
        name: yup.string().trim().required(requiredFieldMessage()),
    })
    .required(requiredFieldMessage());

const initialState = {
    name: '',
};

export const payloadFromSchema = (data: typeof initialState) => {
    return data;
};

interface Props {}

const CreateAdvertisingSegment: FC<Props> = () => {
    const { createAdvertisingSegment, loading, error } = useAdvertisingSegments();
    const navigate = useNavigate();

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: initialState,
    });

    const onSubmit = async (data: any) => {
        const payload = payloadFromSchema(data);

        try {
            await createAdvertisingSegment(payload);
            navigate('/settings/advertising-segment');
        } catch (err) {
            // try again...
        }
    };

    return (
        <AdminSettingsLayout title="Adicionar segmento de publicidade">
            <AdvertisingSegmentForm
                control={control}
                handleSubmit={handleSubmit}
                onSubmit={onSubmit}
                errors={errors} // client-side validation
                error={error} // server-side error
                loading={loading}
            />
        </AdminSettingsLayout>
    );
};

export default CreateAdvertisingSegment;
